/**
 * PICSECT color system — all tokens derived from brand pink #F777B0.
 * Tweak the brand value and everything recalculates from it.
 *
 * To change the overall warmth/tone, edit `brand` and the three
 * background tints (`paper`, `paper2`, `paper3`) — the rest is
 * computed or semantic.
 */

// ── editable base ──────────────────────────────────────────────
const brand = '#FF7AA2';       // primary pink — CTAs, progress, accents
const brandDark = '#FF9E7A';   // coral — over-limit alerts, accent text

// Background tints (derived from warm peach #FFD6A5)
const paper  = '#FFFBF7';      // page bg — barely-there warm
const paper2 = '#FFF4EB';      // sidebar / toolbar bg
const paper3 = '#FFEEDD';      // card bg on paper2, input bg

// Borders — warm sand tones
const hair  = '#EFE2D4';       // subtle border
const hair2 = '#DFD0BE';       // stronger border, disabled

// Text (near-black with warm undertone)
const ink  = '#1A1614';
const ink2 = '#3D3530';
const ink3 = '#8A7E77';

// ── computed / derived ─────────────────────────────────────────
// Lighter brand tint for badges, backgrounds
const brandSoft = '#FFE0EC';

// ── typography ─────────────────────────────────────────────────
const serif = '"Instrument Serif", "Songti SC", serif';
const sans  = '"Inter", "Noto Sans SC", -apple-system, sans-serif';
const mono  = '"JetBrains Mono", ui-monospace, monospace';

// ── semantic ───────────────────────────────────────────────────
const successBg  = '#E3F0E6';
const successFg  = '#3F8F5F';
const warningBg  = '#FFF1E0';
const warningFg  = '#A86B27';
const warningDot  = '#D9883A';
const dangerBg   = '#FBE0E0';
const dangerFg   = '#A53636';
const dangerDot   = '#C53C3C';
const neutralBg  = paper2;
const neutralFg  = ink2;
const neutralDot  = ink3;

// ── export ─────────────────────────────────────────────────────
const C = {
  brand,
  brand2: brandDark,
  brandSoft,
  paper,
  paper2,
  paper3,
  hair,
  hair2,
  ink,
  ink2,
  ink3,
  serif,
  sans,
  mono,
  // semantic
  successBg, successFg,
  warningBg, warningFg, warningDot,
  dangerBg, dangerFg, dangerDot,
  neutralBg, neutralFg, neutralDot,
};

// ── MUI theme palette (imported by theme.js) ───────────────────
export const muiPalette = {
  primary:   { main: brand, contrastText: '#fff' },
  secondary: { main: brandDark, contrastText: '#fff' },
  error:     { main: '#c2185b' },
  wechat:    { main: '#07C160', contrastText: '#fff' },
  background: {
    default: paper,
    paper: '#fff',
  },
};

export default C;
